import { useI18n } from 'vue-i18n';
import { Maybe } from 'graphql/jsutils/Maybe';
import { copyToClipboard } from '../utils';
import { useNotify } from './notify';
import { CONST_NOTIFY } from './CONST';

export const useCopyToClipboard = () => {
  const { toastMessage } = useNotify();
  const { t } = useI18n();

  return (textToCopy?: Maybe<string>) => {
    if (!textToCopy) {
      return;
    }
    copyToClipboard(textToCopy);
    toastMessage(t('generic.copiedToClipboard'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  };
};
